import Vue from "vue";
import axios from "@/axiosConfig";

export default ({
  state:{
    posts: [],
    teachersToFollow: [],
    topLectures: [],
    nextPage: 0,
  },
  actions: {
    getPostsApi({commit}){
        axios.get('/timeline')
        .then(response => {
          commit('SET_POSTS', response);
         })
        .catch(error => {
          console.log(error)
        })
    },
    getNextPostsApi({commit, state}){
      axios.get('/timeline?page=' + state.nextPage)

      .then(response => {
        commit('SET_NEXT_POSTS', response);
       })
      .catch(error => {
        console.log(error)
      })
    },
    getTeachersToFollowApi({commit}){
      axios.get('/teachers-to-follow')
      .then(response => {
        commit('SET_TEACHERS_TO_FOLLOW', response);
       })
      .catch(error => {
        console.log(error)
      })
    },
    followTeacherApi(_, id){
      axios.post('/follow-teacher/' + id)
      .then(response => {
        Vue.$toast.success(response.data.message);
        console.log(response);
       })
      .catch(error => {
        Vue.$toast.error(error.response.data.message);
        console.log(error)
      })
    },
    topLecturesApi({commit}){
      axios.get('/top-lectures')
      .then(response => {
        commit('SET_TOP_LECTURES', response);
        console.log(response);
       })
      .catch(error => {
        console.log(error)
      })
    }
  },
  mutations: {
    SET_POSTS(state, response){
      state.posts = response.data.data;
      state.nextPage = ((response.data.pagination.current_page + 1 ) <= response.data.pagination.last_page) ? response.data.pagination.current_page + 1  : 0;
    },
    SET_NEXT_POSTS(state, response){
      (response.data.data).forEach(element => {
        state.posts.push(element);
      });
      console.log(response.data.pagination);
      state.nextPage = ((response.data.pagination.current_page + 1 ) <= response.data.pagination.last_page) ? response.data.pagination.current_page + 1  : 0;
    },
    SET_TEACHERS_TO_FOLLOW(state, response){
      state.teachersToFollow = response.data.data;
    },
    SET_TOP_LECTURES(state, response){
      state.topLectures = response.data.data;
    }
  },
  getters : {
    posts: state => state.posts,
    nextPage: state => state.nextPage,
    isloadable: state => state.isloadable,
    teachersToFollow: state => state.teachersToFollow,
    topLectures: state => state.topLectures,
  },
  namespaced: true,
});
